module.exports = __webpack_public_path__ + "static/jimmysfresh-91210f5e15d08337277545f9dc0498b6.jpg";